module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/2@2x_f0389dffe1510beb7f06de2fb85c1a3f.png";